import React, { useState } from "react";

import { TextAutoComplete } from "App/Atomics/AutoComplete";
import { findTrackList } from "./findTrackList";
import { Info } from "App/Atomics/AutoComplete/TextAutoComplete";

type Props = Pick<
  Parameters<typeof TextAutoComplete>[0],
  | "style"
  | "className"
  | "classNamePrefix"
  | "isDisabled"
  | "defaultValue"
  | "defaultOptions"
  | "onChange"
  | "onBlur"
  | "autoFocus"
  | "filterOption"
>;

export const TrackTextAutoComplete = ({
  style,
  className,
  classNamePrefix,
  isDisabled,
  defaultValue,
  defaultOptions,
  onChange,
  onBlur,
  autoFocus,
  filterOption
}: Props) => {
  const [initialOptions, setInitialOptions] = useState<Info[] | undefined>(defaultOptions);

  const onFocus = async () => {
    const info = await findTrackList("");
    setInitialOptions(info);
  };
  return (
    <TextAutoComplete
      placeholder="트랙을 입력해주세요."
      isDisabled={isDisabled}
      defaultValue={defaultValue}
      defaultOptions={initialOptions}
      delay={200}
      style={style}
      className={className}
      classNamePrefix={classNamePrefix}
      filterOption={filterOption}
      onFocus={onFocus}
      onChange={onChange}
      onBlur={onBlur}
      autoFocus={autoFocus}
      loadInfoList={findTrackList}
    />
  );
};
